import React, {FC} from 'react';
import {ALIGN, View} from '@lookiero/aurora';
import {VIDEOS_URL} from '@cdn';

const VIDEO_BASE = `${VIDEOS_URL()}/maintenance/v1/maintenance`;

const VIDEO_SOURCES = [
  {src: `${VIDEO_BASE}@1x.mp4`, media: '(max-width: 600px)'},
  {src: `${VIDEO_BASE}@2x.mp4`, media: '(min-width: 601px)'},
];

export const Animation: FC = () => {
  return (
    <View style={{flex: 1}} justifyContent={ALIGN.CENTER} alignContent={ALIGN.CENTER} alignItems={ALIGN.CENTER}>
      <video style={{width: '100%', objectFit: 'cover'}} autoPlay={true} loop muted playsInline>
        {VIDEO_SOURCES.map(({src, media}) => (
          <source key={src} src={src} type="video/mp4" media={media} />
        ))}
      </video>
    </View>
  );
};
